/** Joins class names, skipping falsy values. `cx(styles.button, isPrimary && styles.primary)` */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
